import messages from '../locales/sl_SI.json';

const lang = {
    messages: {
        ...messages,
    },
    locale: 'sl-SI',
};
export default lang;
